/**
 * card de analise de risco TCU. agrupa alertas por severidade, mostra
 * fundamento legal (numero do acordao + link pro portal TCU).
 */

import type { AlertaRisco, SeveridadeT } from '@licita-mind/shared-types';
import { cn } from '../lib/cn';

const SEV_CORES: Readonly<Record<SeveridadeT, string>> = {
  ALTA: 'bg-red-50 border-red-200 text-red-900',
  MEDIA: 'bg-amber-50 border-amber-200 text-amber-900',
  BAIXA: 'bg-blue-50 border-blue-200 text-blue-900',
};

const SEV_BADGE: Readonly<Record<SeveridadeT, string>> = {
  ALTA: 'bg-red-200 text-red-900',
  MEDIA: 'bg-amber-200 text-amber-900',
  BAIXA: 'bg-blue-200 text-blue-900',
};

const SEV_LABEL: Readonly<Record<SeveridadeT, string>> = {
  ALTA: 'alto risco',
  MEDIA: 'risco medio',
  BAIXA: 'atencao',
};

export const AlertaRiscoCard = ({ alerta }: { alerta: AlertaRisco }) => {
  const sev = alerta.severidade;
  return (
    <div className={cn('border rounded-lg p-4', SEV_CORES[sev])}>
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-center gap-2">
          <span className={cn('badge', SEV_BADGE[sev])}>{SEV_LABEL[sev]}</span>
          <code className="text-xs font-mono opacity-70">{alerta.regra_id}</code>
        </div>
      </div>
      <p className="text-sm leading-relaxed mb-3">{alerta.mensagem}</p>
      <div className="text-xs border-t border-current/20 pt-2 mt-2">
        <a
          href={alerta.fundamento_legal.acordao.url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:opacity-70"
        >
          TCU Acordao {alerta.fundamento_legal.acordao.numero}-
          {alerta.fundamento_legal.acordao.orgao} · {alerta.fundamento_legal.acordao.tema}
        </a>
        <p className="mt-1 italic opacity-75">
          {alerta.fundamento_legal.acordao.ementa}
        </p>
      </div>
    </div>
  );
};
